/**
 * Drawer — right-sliding panel. Backdrop rgba(16,24,40,0.32) z40, panel 440px
 * card bg, left border, shadow-lg, slidein anim. Backdrop click closes.
 */
import React from 'react';
import { colors, shadows } from '../theme';

type Props = { width?: number; onClose?: () => void; children: React.ReactNode };

export default function Drawer({ width = 440, onClose, children }: Props) {
  return React.createElement(
    'div',
    {
      className: 't-anim-fadein',
      onClick: onClose,
      style: {
        position: 'fixed',
        inset: 0,
        background: colors.overlaySoft,
        zIndex: 40,
        display: 'flex',
        justifyContent: 'flex-end',
      } as React.CSSProperties,
    },
    React.createElement(
      'div',
      {
        className: 't-anim-slidein',
        onClick: (e: React.MouseEvent) => e.stopPropagation(),
        style: {
          width,
          maxWidth: '100%',
          height: '100%',
          background: colors.card,
          borderLeft: `1px solid ${colors.line}`,
          boxShadow: shadows.lg,
          display: 'flex',
          flexDirection: 'column',
        } as React.CSSProperties,
      },
      children,
    ),
  );
}
